import './styles.css';
import React from 'react';
import Exit from '../../../../images/icons/exit.svg';
import Plus from '../../../../images/icons/plus.svg';
import FileChange from '../../../../images/icons/redo.svg';
import { Form, FormGroup, ControlLabel, FormControl, Button, Modal, Radio } from 'react-bootstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import SelectAsync from 'react-select/lib/Async';
import { CertificatesListSGroups } from '../../../../utils/CertificatesListSGroups';
import _ from "lodash";

class CertificateFormModal extends React.Component {
    static contextTypes = { api: PropTypes.object, notifier: PropTypes.object };

    constructor(props) {
        super(props);
        if (!props.editing) {
            this.state = {
                form: {
                    name: '',
                    congress: {},
                    event: {},
                    type: 'none',
                    orientation: ''
                },
                typeCert: { label: '', value: null },
                imagePreview: {
                    src: ""
                },
                fileCharged: {}
            }
        }
        else {
            let type = 'none';
            let typeCert = { label: '', value: null };
            if (props.editing.congress) {
                type = 'congress';
                typeCert = { label: props.editing.congress.name, value: props.editing.congress.id }
            }
            else if (props.editing.event) {
                type = 'event';
                typeCert = { label: props.editing.event.name, value: props.editing.event.id }
            }
            this.state = {
                form: {
                    name: props.editing.name,
                    congress: props.editing.congress,
                    event: props.editing.event,
                    type: type,
                    orientation: props.editing.orientation === null ? '' : props.editing.orientation
                },
                typeCert: typeCert,
                imagePreview: {
                    src: ""
                },
                fileCharged: {}
            }
        }

        this.textCertificatePreviewCoordinates = {
            position: 'absolute',
            right: '0',
            top: '42%',
            width: '75%'
        }
        this.inputFileRef = React.createRef();
        this.loadCongresses = _.debounce(this.loadCongresses, 250);
    }

    componentDidMount() {
        if (this.props.editing && this.props.editing.templateFile !== null) {
            this.setState({
                imagePreview: { ...this.state.imagePreview, src: this.context.api.appFiles.getUrl(this.props.editing.templateFile.id) }
            });
        }
    }

    loadCongresses = (name) => {
        return this.context.api.congresses.get(0, 10, undefined, { name: name })
            .then((congresses = []) => congresses.map((congress) => ({ value: congress.id, label: congress.name })))
    };

    loadEvents = (name) => {
        return this.context.api.events.get(0, 10, undefined, { name: name })
            .then((events = []) => events.map((event) => ({ value: event.id, label: event.name })))
    };

    onFormChange = ({ target }) => this.setState({ form: { ...this.state.form, [target.name]: target.value } });
    getFormValue = (name) => this.state.form[name] ? this.state.form[name] : '';
    changeRadio = (e) => { return this.setState({ form: { ...this.state.form, type: e, congress: null, event: null }, typeCert: { label: '', value: null } }) };

    getTypeCert = (name) => {
        if (name === this.state.form.type) return this.state.typeCert;
        else return { label: '', value: null }
    };

    changeTypeCert = (e) => this.setState({ form: { ...this.state.form, [e.name]: e.value }, typeCert: { value: e.value.value, label: e.value.label } });

    saveForm = () => {
        if (!this.state.form.name)
            return this.context.notifier.error('No has llenado el campo Nombre');

        if (this.state.imagePreview.src.length > 0) {
            if (!this.state.form.orientation)
                return this.context.notifier.error('Olvidaste especificar la orientación de la constancia (Vertical/Horizontal)');
        }

        if (this.state.form.type === 'congress' && !this.state.form.congress)
            return this.context.notifier.error('Se requiere el nombre del congreso');

        else if (this.state.form.type === 'event' && !this.state.form.event)
            return this.context.notifier.error('Se requiere el nombre del evento');


        let congress = null, event = null;
        if (this.state.form.type === 'congress') {
            congress = this.state.form.congress.value; event = null
        }
        else if (this.state.form.type === 'event') {
            event = this.state.form.event.value; congress = null
        }


        const certificate = {
            sGroups: CertificatesListSGroups,
            "name": this.state.form.name,
            "congress": congress,
            "event": event,
            "orientation": this.state.form.orientation
        };

        const finish = () => {
            if (this.props.didSave) this.props.didSave();
            else if (this.props.onHide) this.props.onHide();
        };

        if (this.props.editing)
            this.context.api.certificates.edit(
                this.props.editing.id,
                certificate,
                '@Class.Certificates.Certificate.edit',
                this.state.fileCharged === null ? null : this.state.fileCharged
            ).then(finish);
        else
            this.context.api.certificates.create(
                certificate,
                '@Class.Certificates.Certificate.create',
                this.state.fileCharged === null ? null : this.state.fileCharged
            ).then(finish);
    };


    loadImage = (event) => {
        const file = event.target.files[0];
        const fileURL = file ? URL.createObjectURL(file) : '';
        this.setState({ fileCharged: file })
        this.setState({ imagePreview: { ...this.state.imagePreview, src: fileURL } });
    };

    removePreviewImage = () => {
        this.setState({ imagePreview: { ...this.state.imagePreview, src: '' } });
        this.inputFileRef.current.value = '';
    };

    changeOrientation = (radioName) => {
        this.setState({ form: { ...this.state.form, orientation: radioName } });
    };


    render() {
        const { onHide } = this.props;
        return (
            <Modal show={true} className="ModalCertificateCreator"
                onHide={onHide}>
                <Modal.Header closeButton>
                    <Modal.Title>{this.props.editing ? 'Editar constancia' : 'Añadir constancia'}</Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <Form className='CongressFormModal'>
                        <FormGroup>
                            <ControlLabel>Nombre:</ControlLabel>
                            <FormControl
                                onKeyPress={event => { if (event.key === "Enter") event.preventDefault(); }}
                                autoFocus={true}
                                placeholder='Nombre de la constancia'
                                name='name'
                                value={this.getFormValue('name')}
                                onChange={this.onFormChange}
                                required />
                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>Pertenece a: &nbsp; </ControlLabel>
                            <Radio
                                inline
                                name="type"
                                checked={this.getFormValue('type') === 'congress'}
                                onChange={() => this.changeRadio('congress')}
                            >Congreso</Radio>
                            <Radio
                                inline
                                name="type"
                                checked={this.getFormValue('type') === 'event'}
                                onChange={() => this.changeRadio('event')}
                            >Evento</Radio>
                            <Radio
                                inline
                                name="type"
                                checked={this.getFormValue('type') === 'none'}
                                onChange={() => this.changeRadio('none')}
                            >Ninguno</Radio>

                        </FormGroup>

                        {this.state.form.type === 'congress' && <FormGroup>
                            <ControlLabel>Nombre del Congreso</ControlLabel>
                            <SelectAsync
                                cacheOptions
                                placeholder='Nombre del congreso'
                                noOptionsMessage={() => "Sin coincidencias"}
                                loadOptions={this.loadCongresses}
                                onChange={(value) => this.changeTypeCert({ name: "congress", value })}
                                value={this.getTypeCert('congress')} />
                        </FormGroup>}
                        {this.state.form.type === 'event' && <FormGroup>
                            <ControlLabel>Nombre del Evento</ControlLabel>
                            <SelectAsync
                                cacheOptions
                                placeholder='Nombre del evento'
                                noOptionsMessage={() => "Sin coincidencias"}
                                loadOptions={this.loadEvents}
                                onChange={(value) => this.changeTypeCert({ name: "event", value })}
                                value={this.getTypeCert('event')} />
                        </FormGroup>}

                        <FormGroup>
                            <ControlLabel>Orientación de la constancia: &nbsp;</ControlLabel>
                            <Radio
                                inline
                                name="orientation"
                                checked={this.getFormValue('orientation') === 'H'}
                                onChange={() => this.changeOrientation('H')}
                            >Horizontal</Radio>
                            <Radio
                                inline
                                name="orientation"
                                checked={this.getFormValue('orientation') === 'V'}
                                onChange={() => this.changeOrientation('V')}>Vertical</Radio>
                        </FormGroup>

                        <FormGroup>
                            <ControlLabel>Añadir plantilla de la constancia:</ControlLabel>
                            <input
                                id="upload-file"
                                type="file"
                                onChange={this.loadImage}
                                ref={this.inputFileRef}
                            />
                            {
                                this.state.imagePreview.src
                                    ? (
                                        <div>
                                            <ControlLabel htmlFor="upload-file" className="interactive">
                                                Cambiar imagen
                                                <img src={FileChange} alt="Cambiar imagen" />
                                            </ControlLabel>
                                        </div>
                                    )
                                    : (
                                        <ControlLabel htmlFor="upload-file" className="interactive">
                                            Añadir Imagen
                                            <img src={Plus} alt="Subir imagen." />
                                        </ControlLabel>
                                    )
                            }
                        </FormGroup>


                        <div className="certificatePreviewContainer">
                            {
                                this.state.imagePreview.src &&
                                <React.Fragment>
                                    {
                                        !this.props.editing &&
                                        <button id="removePreviewImage" type="button" onClick={this.removePreviewImage}>
                                            'Descartar'
                                            <img src={Exit} alt="Descartar archivo." />
                                        </button>
                                    }
                                    {/*
                                    <p
                                        className="text-preview"
                                        style={
                                            this.state.form.name.length > 30
                                                ? { ...this.textCertificatePreviewCoordinates, fontSize: '120%', top: '43%' }
                                                : { ...this.textCertificatePreviewCoordinates, fontSize: 'calc(1rem + 100%)' }
                                        }
                                    >
                                        {this.state.form.name}
                                    </p>
                                    */}
                                    <img
                                        src={this.state.imagePreview.src}
                                        alt={`Certificado para ${this.state.form.name}`}
                                        className="certificatePreview"
                                    />
                                </React.Fragment>
                            }
                        </div>

                        <Button bsStyle='danger'
                            onClick={this.props.onHide}>Cancelar</Button>
                        <Button bsStyle='success'
                            className='pull-right'
                            onClick={this.saveForm}>Guardar</Button>
                    </Form>
                </Modal.Body>
            </Modal>
        );
    }
}

const mapStateToProps = ({ api: { certificates = [], congresses = [], events = [] }, }) => ({ certificates, congresses, events });

export default connect(mapStateToProps)(CertificateFormModal);


// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/scenes/Certificates/components/CertificateFormModal/index.jsx